import _ from 'lodash'
import request from '../tools/request'
import { getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
import { ProductChildParams } from './Params'
import { PagiPromiseResponseData, TableRes } from '../global'
import { ConnectedProjectCode } from '@/modules/goodsdetailmodules/reducer'
const { GET, POST, filePOSTForm, downFilePost, DELETE } = request

// 调用MPM接口匹配类目的税收分类编码
export const getTaxCategoryByCategory = async (
  categoryId: string,
): Promise<string | null> => {
  const res = await GET('/mpm/tax-category', { params: { categoryId } })
  return res?.data?.taxCategoryCode || null
}

export const GET_OWNER_PAGES_API = (params: { supplierid?: string }) =>
  GET(`${HTTP}/product/getOwnerList`, params)

// 分页获取品牌下拉框（弹窗）数据
export const GET_BRAND_PAGES = (param: {
  brandName?: string // 名称 编码
  pageSize: string // 分页尺寸
  pageNo: string // 页码
  supplierId: string // 供应商ID
}) => GET(`${HTTP}/brand/getMdmBrandPage`, param)

// 分页获取部门下拉框（弹窗）数据
export const GET_DEPT_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/department/getDeptSelectPage`, param)

// 分页获取员工下拉框（弹窗）数据
export const GET_PERSON_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/emp/getEmpSelectPage`, param)

// 分页获取考核类别下拉框（弹窗）数据
export const GET_EXAMINECATE_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/examineCategory/getExamineCategorySelectPage`, param)

interface CHECKPARAMS {
  code?: string // 编码
  name?: string // 名称
  model?: string // 型号规格
  brand?: string // 品牌
  categoryId?: string
  pageNo: number
  pageSize: number
  supplierId: string
  schemeId?: string // 搜索方案id
  srmProductType?: string
  unitCode?: string
  platformCodes?: string
  firstPassStart?: string // 咸亨上架开始(起始)
  firstPassEnd?: string // 咸亨上架开始(截止)
  firstPassTimeSortType?: string // 咸亨上架时间排序类型 asc/desc
  submitTimeSortType?: string // 物料提交时间排序类型 asc/desc
  submitTimeStart?: string // 物料提交开始(起始)
  submitTimeEnd?: string // 物料提交开始(截止)
}
// 多条件查询子商品
export const GET_PRODUCTCHILDLIST = (params: CHECKPARAMS) =>
  GET(`${HTTP}/product/getNormalProductPage`, params)

// 获取商品详情
export const GET_PRODUCT_DETAIL = (params: { productId: string }) =>
  GET(`${HTTP}/product/getProductDetail`, params)

// 通过CODE获取商品详情
export const GET_CODEPRODUCT_DETAIL = (params: {
  code: string
  platformCode?: string
}) => GET(`${HTTP}/product/getNormalProductDetail`, params)

// ERP模式新增物料时获取必要数据 四级类目
export const GET_ERP_PRODUCTCHILD_ADD_REQUIRED = (params: {
  categoryId: string
  productType: string
}) => GET(`${HTTP}/product/getExpandName`, params)

// 分页查询枚举属性值
export const PAGE_EXPAND_NAME_ENUM_LIST = (params: {
  fieldNameId: string // 属性项 id
  pageNo: number // 页码
  pageSize: number // 每页数量
  value?: string // 搜索关键词
}) =>
  request.POST<
    TableRes<{
      id: string
      value: string
      fieldNameId: string
    }>
  >(`${HTTP}/product/pageExpandNameEnumList`, params, 'application/json')

// 税收分类编码 - 选码弹窗用的全量树
// 三个条件均为空返回全量；有条件时后端返回命中节点及其全部祖先，祖先 matched 为 false
export const GET_TAX_CATEGORY_TREE = (param?: {
  code?: string
  shortName?: string
  name?: string
}) => GET(`${HTTP}/product/taxCategory/tree`, param)

// 税收分类编码 - 提交前黑名单预校验
// 只传物料类型和税编，货主由 MPM 按物料类型推导（电商供应商物料 1000，其余 1025），
// 前端不要自己算货主。allowed=false 时不得提交，提示语直接用 message
export const POST_TAX_CATEGORY_BLACKLIST_CHECK = (params: {
  srmProductType?: string
  taxCode: string
}) =>
  POST<{
    allowed: boolean
    message: string | null
    shipperCode: string
  }>(`${HTTP}/product/taxCategory/blacklistCheck`, params, 'application/json')

// 智能赋码获取税编信息
export const GET_SMART_REVENUE_DATA = (param: { productName: string }) =>
  request.GET(`${HTTP}/product/intelligentCoding`, param)

// 新增、暂存物料
export const ADD_PRODUCTCHILD = (params: ProductChildParams) =>
  POST(`${HTTP}/product/addProduct`, params, 'application/json')

export const CACHE_PRODUCT = (params: any) =>
  POST(`${HTTP}/cacheStore/productIno`, params, 'application/json')

// 编辑物料
export const EDIT_PRODUCTCHILD = (params: ProductChildParams) =>
  POST(`${HTTP}/product/updateProduct`, params, 'application/json')

export const GET_PRODUCT_CACHE = () => GET(`${HTTP}/cacheStore/productIno`)

export const DELETE_PRODUCT_CACHE = () =>
  DELETE(`${HTTP}/cacheStore/productIno`, {}, 'application/json')

// 获取所有考核类别
export const GET_EXAMINATIONLIST = () =>
  GET(`${HTTP}/examineCategory/getExamineCategoriesByCurrentEmp`)

// 批量提交 增量
export const UPDATE_INCREMENTASSESS = (params: {
  paramData: {
    id: string
    mainPicture: string
    detailsPicture: string
    extendedAttribute: string
    tempCode: string
  }[]
  supplierId: string
}) => POST(`${HTTP}/product/submitMyProduct`, params, 'application/json')

// 批量删除 增量
export const DEL_INCREMENTASSESS = (params: { productIds: string }) =>
  POST(`${HTTP}/product/deleteProduct`, params, 'application/json', params)

// 获取考核类别
export const GET_TYPE_API = (params: { deptId: string }) =>
  GET(`${HTTP}/examineCategory/getExamineCategoriesByDept`, params)

// 获取全部单位
export const GET_ALLUNIT_API = (name = '') =>
  GET(`${HTTP}/product/getUnitList`, { name })

/**
 * MPMUnitVO
 */
export interface MPMUnitVO {
  erpId?: string
  name?: string
  precision?: number
  spell?: string
  unit?: string
  [property: string]: any
}
export const GET_UNIT_PAGE = (params: {
  name?: string
  pageNo: number
  pageSize: number
}): PagiPromiseResponseData<MPMUnitVO[]> =>
  GET(`${HTTP}/product/getUnitListPage`, params)

// 获取物料的考核人员信息
export const GET_PRODUCT_CHECKMAN_API = (params: {
  key?: string
  limit: number
  page: number
}) => GET(`${HTTP}/emp/getExaminerSelectPage`, params)

// 获取四级类目 传入 cate 只展示四级类目，传入 pro ，会有第五级，第五级是父商品，默认 cate
export const GET_TREENODE_API = (params: { pid?: string; type?: string }) =>
  GET(`${HTTP}/category/getCategoryData`, params)

export interface AiCategoryRecommendItem {
  categoryId: string
  categoryName: string
  categoryCode: string
  categoryTree: string
  parentId?: string
  confidence: number
  reason?: string
}

export const GET_AI_CATEGORY_RECOMMEND = (params: {
  materialName: string
  description?: string
}): Promise<{ code: number; data: AiCategoryRecommendItem[] }> =>
  POST(`${HTTP}/category/aiCategoryRecommend`, params, 'application/json')

// 已存量撤回
export const POST_RECALL_API = (param: { productId: string }) =>
  POST(`${HTTP}/product/backProduct`, param, 'application/json', param)

// 获取操作记录
export const GET_RECORDDETAIL = (param: { productId: string }) =>
  GET(`${HTTP}/productChild/getProductOperateRecord`, param)

interface AuditListParams {
  brand: string
  checkMan: string
  checkState: string
  model: string
  name: string
  pageNo: number
  pageSize: number
  supplierId: string
  auditStartDate: string
  auditEndDate: string
  // endDate?: string
  // startDate?: string
  schemeId?: string // 搜索方案id
  tempCode?: string
  unitCode?: string
}

export type AuditListRes = {
  brand: string
  checkMan: string
  checkTime: string
  des: string
  fourthCateMdmId: string
  id: string
  model: string
  name: string
  purchasePrice: string
  state: string
  tempCode: string
  unitName: string
}

// 获取审核列表
export const GET_AUDITLIST = (params: AuditListParams) =>
  GET<TableRes<AuditListRes>>(`${HTTP}/product/getCheckProductPage`, params)

// 临时CODE
export const GET_MARKUP_TEMPCODE = (params: {
  supplierCode: string
  supplierId: string
  preCode?: string
}) =>
  POST(`${HTTP}/product/getTempProductCode`, params, 'application/json', params)

interface BrandPage {
  pageNo: number
  pageSize: number
  supplierId: string
  brandName?: string
}
// 获取品牌列表
export const GET_BRANDPAGE = (params: BrandPage) =>
  GET(`${HTTP}/brand/getMdmBrandPage`, params)

interface BRANDLICENCE {
  brands?: string
  supplierId: string
  type: string
  fileAddParamList: any[]
  brandNameParamDTOS?: {
    brandNameCn: string
    brandNameEn: string
  }[]
  logo?: string
}
export const ADD_BRANDLICENCE = (pramas: BRANDLICENCE) =>
  POST(`${HTTP}/brand/addBrandAuthorization`, pramas, 'application/json')

// 获取授权详情
export const GET_BRANDLICENCE = (pramas: { id: string }) =>
  GET(`${HTTP}/brand/getBrandAuthorizationById`, pramas)

// 修改品牌授权
export const UPDATE_BRANDLICENCE = (pramas: BRANDLICENCE) =>
  POST(`${HTTP}/brand/updateBrandAuthorization`, pramas, 'application/json')

// 获取合作协议
export const GET_COOPERATION_AGREEMENT = (pramas: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getCooperationAgreementDataDTOList`, pramas)

interface AddAgreementParams {
  fileAddParamList: {
    fileName: string
    licenceUrl: string
  }
  level: string
  supplierInGroupId: string
}

// 新增合作协议信息
export const POST_ADD_COOPERATION_AGREEMENT = (pramas: AddAgreementParams) =>
  POST(
    `${HTTP}/supplier/addCooperationAgreementBySupplierInGroupId`,
    pramas,
    'application/json',
  )

// 获取资质证照信息
export const GET_SUPPLIER_QUALIFICATIONS = (pramas: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getSupplierDetailFileList`, pramas)

export type BatchImportParam = {
  file: any
  imgs: {
    imgName: string
    imgUrl: string
  }[]
  productType: string // 物料类型
}

/**
 * 批量物料导入开始导入
 * @param pramas
 * @returns
 */
export const IMPORT_PRODUCT_BY_PROJECT = (params: BatchImportParam) =>
  filePOSTForm(`${HTTP}/product/importProductByProject`, params.file, {
    ..._.omit(params, ['file']),
    userId: getUserId(),
    supplierId: getSupplierId(),
  })

// {
//   "code": 0,
//   "data": true,
//   "msg": "string"
// }
// data为false校验失败
// msg = '1'  关联项目不一致
// msg = '2'  非该物料的导入模板

/**
 * 导入excel进行校验
 * @param params
 * @returns
 */
export const CHECK_PRODUCT_FILE = (params: {
  file: any
  projectTypeDTOList: ProjectTypeDTOItem[]
}) =>
  filePOSTForm(`${HTTP}/product/checkProductFile`, params.file, {
    ..._.omit(params, ['file']),
  })

export type ProductExcelParam = {
  projectTypeDTOList: ProjectTypeDTOItem[]
}
/**
 * 下载导入excel模板
 * @param params
 * @returns
 */
export const DOWN_GOODS_IMPORT_TEMPLATE = (params: ProductExcelParam) =>
  downFilePost(`${HTTP}/product/downloadProductTemp`, params)

export type GoodsListParam = {
  brand?: string // 物料品牌
  code?: string // 编码
  detailsPicture?: string // 详情图
  extendedAttribute?: string // 拓展属性
  mainPicture?: string // 主图
  model?: string // 规格
  name?: string // 物料名称
  productType?: string // 物料类型
  referenceSupplyPrice?: string // 参考供货价
  relevancyPlatform?: string // 关联项目
  pageNo: number
  pageSize: number
  schemeId?: string // 搜索方案id
  unit?: string // 单位
  userId?: string // 登陆人Id
  supplierId?: string
  srmProductType?: string
}
export type GoodsListRes = {
  brand: string
  code: string
  detailsPicture: string
  extendedAttribute: string
  mainPicture: string
  model: string
  name: string
  productType: string
  referenceSupplyPrice: string
  relevancyPlatform: string
  unit: string
}

export const GET_GOODS_LIST = (params: GoodsListParam) =>
  GET<TableRes<GoodsListRes>>(`${HTTP}/product/unreviewed/page`, {
    userId: getUserId(),
    supplierId: getSupplierId(),
    ...params,
  })

export type ProjectListRes = { platformCode: string; platformName: string }
/**
 * 获取供应商关联的项目列表
 * @param params
 * @returns
 */
export const GET_PROJECT_LIST = () =>
  GET<ProjectListRes[]>(`${HTTP}/product/getSupplierPerformanceList`, {
    supplierId: getSupplierId(),
  })

export type ProjectTypeDTOItem = {
  projectName: string
  projectType: string
}
/**
 * 下载上架项目导入模板
 * @param params
 * @returns
 */
export const DOWN_PROJECT_TEMPLATE = (params: {
  productIds?: string[]
  projects: ProjectTypeDTOItem[]
}) => downFilePost(`${HTTP}/product/downloadUpdateProjectTemp`, params)

/**
 * 下载图片导入模板
 * @param params
 * @returns
 */
export const DOWNLOAD_PICTURE_TEMPLATE = (params: {
  productIds: string[]
  // projects: ProjectTypeDTOItem[]
}) => downFilePost(`${HTTP}/product/downloadUpdatePictureTemp`, params)

/**
 * 下载拓展属性模板
 * @param params
 * @returns
 */
export const DOWNLOAD_EXTEND_TEMPLATE = (params: {
  productIds: string[]
  // projects: ProjectTypeDTOItem[]
}) =>
  downFilePost(`${HTTP}/product/downloadUpdateExtendTemp`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 待提交物料编辑
export const POST_EDIT_TO_SUBMIT_PRODUCT = (params: ProductChildParams) =>
  POST(`${HTTP}/product/updateUnreviewedProduct`, params, 'application/json')

// 获取GH03类目信息
export const GET_GH03_CATEGORY = () =>
  GET(`${HTTP}/product/getAppointCategoryInfo`)

/**
 * 我的申请 获取审核人
 * @param params
 * @returns
 */
export const GET_CHECKMAN = (params: {
  productId: string // 商品id
}) => GET<string>(`${HTTP}/product/checkMan`, params)

// 拾贝提取物料信息
export interface ShibeiProductData {
  barCode: string // 条形码
  brandCode: string // 品牌code
  brandId: string // 品牌Id
  brandIsSale: string // 品牌是否可售
  brandName: string // 品牌名称
  categoryCode: string // 所属类目code
  categoryId: string // 类目id
  categoryName: string // 所属类目名称
  mallPrice: string // 商城价
  manuCode: string // 型号规格
  marketPrice: string // 市场价
  name: string // 名称
  shelfState: string // 商城上下架
  shiBeiBrandName: string // 拾贝品牌名称
  shiBeiCategoryName: string // 类目
  contentUrlList: string[] // 详情图
  picList: {
    baseUrl: string
    url: string
    name: string
  }[] // 主图
  cateName?: string
  fourthCateMdmId?: string
}

// 通过拾贝处理链接，获取拾贝数据
export const POST_SHIBEI_URL_HANDEL = (param: { url: string }) =>
  POST<ShibeiProductData>(
    `${HTTP}/shiBei/receiveShiBeiProduct`,
    param,
    'multipart/form-data',
  )

// 导出物料参数
export interface exportProductParams {
  srmProductType: string // 物料类型
  code: string // 编码
  name: string // 商品名称
  brand: string // 品牌
  model: string // 规格型号
  unitCode: string // 单位
  platformCodes: string // 关联项目
  codeList: string[] // 选中项code
  schemeId: string
  categoryId: string
}
// 导出物料明细
export const EXPORT_NORMAL_PRODUCT = (param: exportProductParams) =>
  GET(`${HTTP}/product/exportNormalProduct`, {
    ...param,
    supplierId: getSupplierId(),
  })

export interface ImportDetail {
  errorInfo: string[]
  failNumber: number
  productInfo: any[]
  successNumber: number
}
// 导入商品报备文件
export const IMPORT_FILING_PRODUCT = (file: any) =>
  POST<ImportDetail>(
    `${HTTP}/filing/importProduct`,
    { file },
    'multipart/form-data',
  )

export const GET_BRAND_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getBrandListPage`, param)

export const GET_CATEGORY_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getCategoryListPage`, param)

export const GET_UNIT_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getUnitListPage`, param)

// 获取外联价格
export const GET_SHIBEI_PRICE_INFO = (params: {
  externalNum: string
  internalNum: string
  url: string
  marketPrice: string
  platformType: string
}) =>
  request.GET<
    | number
    | {
        salePrice: string | number
        commentCount?: number
      }
  >(`${HTTP}/product/shiBei/salePrice`, params)

// 根据四级类目编码查询类目税收信息
export const GET_TAXINFO_BY_CATEGORYCODE = (params: { categoryCode: string }) =>
  request.GET(`${HTTP}/product/getTaxInfoByCategoryCode`, params)

// 获取拾贝token
export const GET_SHIBEI_TOKEN = () =>
  GET<string>(`${HTTP}/product/getShiBeiToken`)

// 拾贝抠图接口返回的文件信息类型
export interface FileDTO {
  baseUrl: string // 前缀路径
  id: string // id
  name: string // 附件名
  type: string // 文件类型
  url: string // 附件路径
}

// 拾贝抠图
export const SHIBEI_KOUTU = (params: {
  productCode?: string // productCode
  url?: string // url
}) => GET<FileDTO[]>(`${HTTP}/product/shiBeiImageCutting`, params)

// 人脸模糊
export const SHIBEI_FACE_BLUR = (params: {
  productCode?: string // productCode
  url?: string // url
  type?: 'detailsPicture' | 'mainPicture'
}) => GET<FileDTO>(`${HTTP}/product/blurryFace`, params)

// 获取已对接项目编码
export const GET_CONNECTED_PROJECT_CODE_LIST = () =>
  GET<ConnectedProjectCode[]>(`${HTTP}/product/getConnectedProjectCode`, {
    supplierId: getSupplierId(),
  })

// 物料预审接口
export interface PreCheckErrors {
  brandError?: string // 品牌相关错误信息
  marketPriceError?: string // 价格相关错误信息
  sugMallPrice?: string // 建议市场价
  picturesError?: string // 主图相关错误信息
  detailsPicturesError?: string // 详情图相关错误信息
  extendedAttributeError?: Record<string, string> // 拓展属性错误信息（key -> message 映射）
  blackListError?: string // 供应商提报黑名单校验失败提示
}
export interface PreCheckResult {
  success: boolean // 是否预审通过
  errorList?: PreCheckErrors // 预审失败的错误信息（按类型分组）
  passedItems?: string[] // 预审通过的项列表
  reviewer?: string // 审核人
}
// 物料预审
export const POST_PRODUCT_PRECHECK = (params: any) =>
  POST<PreCheckResult>(
    `${HTTP}/material/report/preReviewOfMaterials`,
    params,
    'application/json',
  )
import _ from 'lodash'
import request from '../tools/request'
import { getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
import { ProductChildParams } from './Params'
import { PagiPromiseResponseData, TableRes } from '../global'
import { ConnectedProjectCode } from '@/modules/goodsdetailmodules/reducer'
const { GET, POST, filePOSTForm, downFilePost, DELETE } = request

// 调用MPM接口匹配类目的税收分类编码
export const getTaxCategoryByCategory = async (
  categoryId: string,
): Promise<string | null> => {
  const res = await GET('/mpm/tax-category', { params: { categoryId } })
  return res?.data?.taxCategoryCode || null
}

export const GET_OWNER_PAGES_API = (params: { supplierid?: string }) =>
  GET(`${HTTP}/product/getOwnerList`, params)

// 分页获取品牌下拉框（弹窗）数据
export const GET_BRAND_PAGES = (param: {
  brandName?: string // 名称 编码
  pageSize: string // 分页尺寸
  pageNo: string // 页码
  supplierId: string // 供应商ID
}) => GET(`${HTTP}/brand/getMdmBrandPage`, param)

// 分页获取部门下拉框（弹窗）数据
export const GET_DEPT_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/department/getDeptSelectPage`, param)

// 分页获取员工下拉框（弹窗）数据
export const GET_PERSON_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/emp/getEmpSelectPage`, param)

// 分页获取考核类别下拉框（弹窗）数据
export const GET_EXAMINECATE_PAGES_API = (param: {
  key?: string // 名称 编码
  limit: string // 分页尺寸
  page: string // 页码
}) => GET(`${HTTP}/examineCategory/getExamineCategorySelectPage`, param)

interface CHECKPARAMS {
  code?: string // 编码
  name?: string // 名称
  model?: string // 型号规格
  brand?: string // 品牌
  categoryId?: string
  pageNo: number
  pageSize: number
  supplierId: string
  schemeId?: string // 搜索方案id
  srmProductType?: string
  unitCode?: string
  platformCodes?: string
  firstPassStart?: string // 咸亨上架开始(起始)
  firstPassEnd?: string // 咸亨上架开始(截止)
  firstPassTimeSortType?: string // 咸亨上架时间排序类型 asc/desc
  submitTimeSortType?: string // 物料提交时间排序类型 asc/desc
  submitTimeStart?: string // 物料提交开始(起始)
  submitTimeEnd?: string // 物料提交开始(截止)
}
// 多条件查询子商品
export const GET_PRODUCTCHILDLIST = (params: CHECKPARAMS) =>
  GET(`${HTTP}/product/getNormalProductPage`, params)

// 获取商品详情
export const GET_PRODUCT_DETAIL = (params: { productId: string }) =>
  GET(`${HTTP}/product/getProductDetail`, params)

// 通过CODE获取商品详情
export const GET_CODEPRODUCT_DETAIL = (params: {
  code: string
  platformCode?: string
}) => GET(`${HTTP}/product/getNormalProductDetail`, params)

// ERP模式新增物料时获取必要数据 四级类目
export const GET_ERP_PRODUCTCHILD_ADD_REQUIRED = (params: {
  categoryId: string
  productType: string
}) => GET(`${HTTP}/product/getExpandName`, params)

// 分页查询枚举属性值
export const PAGE_EXPAND_NAME_ENUM_LIST = (params: {
  fieldNameId: string // 属性项 id
  pageNo: number // 页码
  pageSize: number // 每页数量
  value?: string // 搜索关键词
}) =>
  request.POST<
    TableRes<{
      id: string
      value: string
      fieldNameId: string
    }>
  >(`${HTTP}/product/pageExpandNameEnumList`, params, 'application/json')

// 税收分类编码 - 选码弹窗用的全量树
// 三个条件均为空返回全量；有条件时后端返回命中节点及其全部祖先，祖先 matched 为 false
export const GET_TAX_CATEGORY_TREE = (param?: {
  code?: string
  shortName?: string
  name?: string
}) => GET(`${HTTP}/product/taxCategory/tree`, param)

// 税收分类编码 - 提交前黑名单预校验
// 只传物料类型和税编，货主由 MPM 按物料类型推导（电商供应商物料 1000，其余 1025），
// 前端不要自己算货主。allowed=false 时不得提交，提示语直接用 message
export const POST_TAX_CATEGORY_BLACKLIST_CHECK = (params: {
  srmProductType?: string
  taxCode: string
}) =>
  POST<{
    allowed: boolean
    message: string | null
    shipperCode: string
  }>(`${HTTP}/product/taxCategory/blacklistCheck`, params, 'application/json')

// 智能赋码获取税编信息
export const GET_SMART_REVENUE_DATA = (param: { productName: string }) =>
  request.GET(`${HTTP}/product/intelligentCoding`, param)

// 新增、暂存物料
export const ADD_PRODUCTCHILD = (params: ProductChildParams) =>
  POST(`${HTTP}/product/addProduct`, params, 'application/json')

export const CACHE_PRODUCT = (params: any) =>
  POST(`${HTTP}/cacheStore/productIno`, params, 'application/json')

// 编辑物料
export const EDIT_PRODUCTCHILD = (params: ProductChildParams) =>
  POST(`${HTTP}/product/updateProduct`, params, 'application/json')

export const GET_PRODUCT_CACHE = () => GET(`${HTTP}/cacheStore/productIno`)

export const DELETE_PRODUCT_CACHE = () =>
  DELETE(`${HTTP}/cacheStore/productIno`, {}, 'application/json')

// 获取所有考核类别
export const GET_EXAMINATIONLIST = () =>
  GET(`${HTTP}/examineCategory/getExamineCategoriesByCurrentEmp`)

// 批量提交 增量
export const UPDATE_INCREMENTASSESS = (params: {
  paramData: {
    id: string
    mainPicture: string
    detailsPicture: string
    extendedAttribute: string
    tempCode: string
  }[]
  supplierId: string
}) => POST(`${HTTP}/product/submitMyProduct`, params, 'application/json')

// 批量删除 增量
export const DEL_INCREMENTASSESS = (params: { productIds: string }) =>
  POST(`${HTTP}/product/deleteProduct`, params, 'application/json', params)

// 获取考核类别
export const GET_TYPE_API = (params: { deptId: string }) =>
  GET(`${HTTP}/examineCategory/getExamineCategoriesByDept`, params)

// 获取全部单位
export const GET_ALLUNIT_API = (name = '') =>
  GET(`${HTTP}/product/getUnitList`, { name })

/**
 * MPMUnitVO
 */
export interface MPMUnitVO {
  erpId?: string
  name?: string
  precision?: number
  spell?: string
  unit?: string
  [property: string]: any
}
export const GET_UNIT_PAGE = (params: {
  name?: string
  pageNo: number
  pageSize: number
}): PagiPromiseResponseData<MPMUnitVO[]> =>
  GET(`${HTTP}/product/getUnitListPage`, params)

// 获取物料的考核人员信息
export const GET_PRODUCT_CHECKMAN_API = (params: {
  key?: string
  limit: number
  page: number
}) => GET(`${HTTP}/emp/getExaminerSelectPage`, params)

// 获取四级类目 传入 cate 只展示四级类目，传入 pro ，会有第五级，第五级是父商品，默认 cate
export const GET_TREENODE_API = (params: { pid?: string; type?: string }) =>
  GET(`${HTTP}/category/getCategoryData`, params)

export interface AiCategoryRecommendItem {
  categoryId: string
  categoryName: string
  categoryCode: string
  categoryTree: string
  parentId?: string
  confidence: number
  reason?: string
}

export const GET_AI_CATEGORY_RECOMMEND = (params: {
  materialName: string
  description?: string
}): Promise<{ code: number; data: AiCategoryRecommendItem[] }> =>
  POST(`${HTTP}/category/aiCategoryRecommend`, params, 'application/json')

// 已存量撤回
export const POST_RECALL_API = (param: { productId: string }) =>
  POST(`${HTTP}/product/backProduct`, param, 'application/json', param)

// 获取操作记录
export const GET_RECORDDETAIL = (param: { productId: string }) =>
  GET(`${HTTP}/productChild/getProductOperateRecord`, param)

interface AuditListParams {
  brand: string
  checkMan: string
  checkState: string
  model: string
  name: string
  pageNo: number
  pageSize: number
  supplierId: string
  auditStartDate: string
  auditEndDate: string
  // endDate?: string
  // startDate?: string
  schemeId?: string // 搜索方案id
  tempCode?: string
  unitCode?: string
}

export type AuditListRes = {
  brand: string
  checkMan: string
  checkTime: string
  des: string
  fourthCateMdmId: string
  id: string
  model: string
  name: string
  purchasePrice: string
  state: string
  tempCode: string
  unitName: string
}

// 获取审核列表
export const GET_AUDITLIST = (params: AuditListParams) =>
  GET<TableRes<AuditListRes>>(`${HTTP}/product/getCheckProductPage`, params)

// 临时CODE
export const GET_MARKUP_TEMPCODE = (params: {
  supplierCode: string
  supplierId: string
  preCode?: string
}) =>
  POST(`${HTTP}/product/getTempProductCode`, params, 'application/json', params)

interface BrandPage {
  pageNo: number
  pageSize: number
  supplierId: string
  brandName?: string
}
// 获取品牌列表
export const GET_BRANDPAGE = (params: BrandPage) =>
  GET(`${HTTP}/brand/getMdmBrandPage`, params)

interface BRANDLICENCE {
  brands?: string
  supplierId: string
  type: string
  fileAddParamList: any[]
  brandNameParamDTOS?: {
    brandNameCn: string
    brandNameEn: string
  }[]
  logo?: string
}
export const ADD_BRANDLICENCE = (pramas: BRANDLICENCE) =>
  POST(`${HTTP}/brand/addBrandAuthorization`, pramas, 'application/json')

// 获取授权详情
export const GET_BRANDLICENCE = (pramas: { id: string }) =>
  GET(`${HTTP}/brand/getBrandAuthorizationById`, pramas)

// 修改品牌授权
export const UPDATE_BRANDLICENCE = (pramas: BRANDLICENCE) =>
  POST(`${HTTP}/brand/updateBrandAuthorization`, pramas, 'application/json')

// 获取合作协议
export const GET_COOPERATION_AGREEMENT = (pramas: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getCooperationAgreementDataDTOList`, pramas)

interface AddAgreementParams {
  fileAddParamList: {
    fileName: string
    licenceUrl: string
  }
  level: string
  supplierInGroupId: string
}

// 新增合作协议信息
export const POST_ADD_COOPERATION_AGREEMENT = (pramas: AddAgreementParams) =>
  POST(
    `${HTTP}/supplier/addCooperationAgreementBySupplierInGroupId`,
    pramas,
    'application/json',
  )

// 获取资质证照信息
export const GET_SUPPLIER_QUALIFICATIONS = (pramas: { supplierId: string }) =>
  GET(`${HTTP}/supplier/getSupplierDetailFileList`, pramas)

export type BatchImportParam = {
  file: any
  imgs: {
    imgName: string
    imgUrl: string
  }[]
  productType: string // 物料类型
}

/**
 * 批量物料导入开始导入
 * @param pramas
 * @returns
 */
export const IMPORT_PRODUCT_BY_PROJECT = (params: BatchImportParam) =>
  filePOSTForm(`${HTTP}/product/importProductByProject`, params.file, {
    ..._.omit(params, ['file']),
    userId: getUserId(),
    supplierId: getSupplierId(),
  })

// {
//   "code": 0,
//   "data": true,
//   "msg": "string"
// }
// data为false校验失败
// msg = '1'  关联项目不一致
// msg = '2'  非该物料的导入模板

/**
 * 导入excel进行校验
 * @param params
 * @returns
 */
export const CHECK_PRODUCT_FILE = (params: {
  file: any
  projectTypeDTOList: ProjectTypeDTOItem[]
}) =>
  filePOSTForm(`${HTTP}/product/checkProductFile`, params.file, {
    ..._.omit(params, ['file']),
  })

export type ProductExcelParam = {
  projectTypeDTOList: ProjectTypeDTOItem[]
}
/**
 * 下载导入excel模板
 * @param params
 * @returns
 */
export const DOWN_GOODS_IMPORT_TEMPLATE = (params: ProductExcelParam) =>
  downFilePost(`${HTTP}/product/downloadProductTemp`, params)

export type GoodsListParam = {
  brand?: string // 物料品牌
  code?: string // 编码
  detailsPicture?: string // 详情图
  extendedAttribute?: string // 拓展属性
  mainPicture?: string // 主图
  model?: string // 规格
  name?: string // 物料名称
  productType?: string // 物料类型
  referenceSupplyPrice?: string // 参考供货价
  relevancyPlatform?: string // 关联项目
  pageNo: number
  pageSize: number
  schemeId?: string // 搜索方案id
  unit?: string // 单位
  userId?: string // 登陆人Id
  supplierId?: string
  srmProductType?: string
}
export type GoodsListRes = {
  brand: string
  code: string
  detailsPicture: string
  extendedAttribute: string
  mainPicture: string
  model: string
  name: string
  productType: string
  referenceSupplyPrice: string
  relevancyPlatform: string
  unit: string
}

export const GET_GOODS_LIST = (params: GoodsListParam) =>
  GET<TableRes<GoodsListRes>>(`${HTTP}/product/unreviewed/page`, {
    userId: getUserId(),
    supplierId: getSupplierId(),
    ...params,
  })

export type ProjectListRes = { platformCode: string; platformName: string }
/**
 * 获取供应商关联的项目列表
 * @param params
 * @returns
 */
export const GET_PROJECT_LIST = () =>
  GET<ProjectListRes[]>(`${HTTP}/product/getSupplierPerformanceList`, {
    supplierId: getSupplierId(),
  })

export type ProjectTypeDTOItem = {
  projectName: string
  projectType: string
}
/**
 * 下载上架项目导入模板
 * @param params
 * @returns
 */
export const DOWN_PROJECT_TEMPLATE = (params: {
  productIds?: string[]
  projects: ProjectTypeDTOItem[]
}) => downFilePost(`${HTTP}/product/downloadUpdateProjectTemp`, params)

/**
 * 下载图片导入模板
 * @param params
 * @returns
 */
export const DOWNLOAD_PICTURE_TEMPLATE = (params: {
  productIds: string[]
  // projects: ProjectTypeDTOItem[]
}) => downFilePost(`${HTTP}/product/downloadUpdatePictureTemp`, params)

/**
 * 下载拓展属性模板
 * @param params
 * @returns
 */
export const DOWNLOAD_EXTEND_TEMPLATE = (params: {
  productIds: string[]
  // projects: ProjectTypeDTOItem[]
}) =>
  downFilePost(`${HTTP}/product/downloadUpdateExtendTemp`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 待提交物料编辑
export const POST_EDIT_TO_SUBMIT_PRODUCT = (params: ProductChildParams) =>
  POST(`${HTTP}/product/updateUnreviewedProduct`, params, 'application/json')

// 获取GH03类目信息
export const GET_GH03_CATEGORY = () =>
  GET(`${HTTP}/product/getAppointCategoryInfo`)

/**
 * 我的申请 获取审核人
 * @param params
 * @returns
 */
export const GET_CHECKMAN = (params: {
  productId: string // 商品id
}) => GET<string>(`${HTTP}/product/checkMan`, params)

// 拾贝提取物料信息
export interface ShibeiProductData {
  barCode: string // 条形码
  brandCode: string // 品牌code
  brandId: string // 品牌Id
  brandIsSale: string // 品牌是否可售
  brandName: string // 品牌名称
  categoryCode: string // 所属类目code
  categoryId: string // 类目id
  categoryName: string // 所属类目名称
  mallPrice: string // 商城价
  manuCode: string // 型号规格
  marketPrice: string // 市场价
  name: string // 名称
  shelfState: string // 商城上下架
  shiBeiBrandName: string // 拾贝品牌名称
  shiBeiCategoryName: string // 类目
  contentUrlList: string[] // 详情图
  picList: {
    baseUrl: string
    url: string
    name: string
  }[] // 主图
  cateName?: string
  fourthCateMdmId?: string
}

// 通过拾贝处理链接，获取拾贝数据
export const POST_SHIBEI_URL_HANDEL = (param: { url: string }) =>
  POST<ShibeiProductData>(
    `${HTTP}/shiBei/receiveShiBeiProduct`,
    param,
    'multipart/form-data',
  )

// 导出物料参数
export interface exportProductParams {
  srmProductType: string // 物料类型
  code: string // 编码
  name: string // 商品名称
  brand: string // 品牌
  model: string // 规格型号
  unitCode: string // 单位
  platformCodes: string // 关联项目
  codeList: string[] // 选中项code
  schemeId: string
  categoryId: string
}
// 导出物料明细
export const EXPORT_NORMAL_PRODUCT = (param: exportProductParams) =>
  GET(`${HTTP}/product/exportNormalProduct`, {
    ...param,
    supplierId: getSupplierId(),
  })

export interface ImportDetail {
  errorInfo: string[]
  failNumber: number
  productInfo: any[]
  successNumber: number
}
// 导入商品报备文件
export const IMPORT_FILING_PRODUCT = (file: any) =>
  POST<ImportDetail>(
    `${HTTP}/filing/importProduct`,
    { file },
    'multipart/form-data',
  )

export const GET_BRAND_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getBrandListPage`, param)

export const GET_CATEGORY_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getCategoryListPage`, param)

export const GET_UNIT_LIST = (param: {
  name?: string // 名称 编码
  pageSize: number // 分页尺寸
  pageNo: number // 页码
}) => GET(`${HTTP}/product/getUnitListPage`, param)

// 获取外联价格
export const GET_SHIBEI_PRICE_INFO = (params: {
  externalNum: string
  internalNum: string
  url: string
  marketPrice: string
  platformType: string
}) =>
  request.GET<
    | number
    | {
        salePrice: string | number
        commentCount?: number
      }
  >(`${HTTP}/product/shiBei/salePrice`, params)

// 根据四级类目编码查询类目税收信息
export const GET_TAXINFO_BY_CATEGORYCODE = (params: { categoryCode: string }) =>
  request.GET(`${HTTP}/product/getTaxInfoByCategoryCode`, params)

// 获取拾贝token
export const GET_SHIBEI_TOKEN = () =>
  GET<string>(`${HTTP}/product/getShiBeiToken`)

// 拾贝抠图接口返回的文件信息类型
export interface FileDTO {
  baseUrl: string // 前缀路径
  id: string // id
  name: string // 附件名
  type: string // 文件类型
  url: string // 附件路径
}

// 拾贝抠图
export const SHIBEI_KOUTU = (params: {
  productCode?: string // productCode
  url?: string // url
}) => GET<FileDTO[]>(`${HTTP}/product/shiBeiImageCutting`, params)

// 人脸模糊
export const SHIBEI_FACE_BLUR = (params: {
  productCode?: string // productCode
  url?: string // url
  type?: 'detailsPicture' | 'mainPicture'
}) => GET<FileDTO>(`${HTTP}/product/blurryFace`, params)

// 获取已对接项目编码
export const GET_CONNECTED_PROJECT_CODE_LIST = () =>
  GET<ConnectedProjectCode[]>(`${HTTP}/product/getConnectedProjectCode`, {
    supplierId: getSupplierId(),
  })

// 物料预审接口
export interface PreCheckErrors {
  brandError?: string // 品牌相关错误信息
  marketPriceError?: string // 价格相关错误信息
  sugMallPrice?: string // 建议市场价
  picturesError?: string // 主图相关错误信息
  detailsPicturesError?: string // 详情图相关错误信息
  extendedAttributeError?: Record<string, string> // 拓展属性错误信息（key -> message 映射）
  blackListError?: string // 供应商提报黑名单校验失败提示
}
export interface PreCheckResult {
  success: boolean // 是否预审通过
  errorList?: PreCheckErrors // 预审失败的错误信息（按类型分组）
  passedItems?: string[] // 预审通过的项列表
  reviewer?: string // 审核人
}
// 物料预审
export const POST_PRODUCT_PRECHECK = (params: any) =>
  POST<PreCheckResult>(
    `${HTTP}/material/report/preReviewOfMaterials`,
    params,
    'application/json',
  )
